import React from "react";
import Header from "../../components/header";

const Consent = () => {
  return (
    <div>
      <>
        <Header hideSearchBar={true} hideAddNew={true} hideHome={true} />
        Consent
      </>
    </div>
  );
};

export default Consent;
